export default "__VITE_ASSET__1b696a6e__"